import { render } from "./CreateCollection.vue?vue&type=template&id=4ac5ad62"
import script from "./CreateCollection.vue?vue&type=script&lang=js"
export * from "./CreateCollection.vue?vue&type=script&lang=js"
script.render = render

export default script